// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("./Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("./GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var Paging_PageMarkers = require("./Paging_PageMarkers.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");

function next(param_0) {
  return {
          TAG: /* Next */0,
          _0: param_0
        };
}

function prev(param_0) {
  return {
          TAG: /* Prev */1,
          _0: param_0
        };
}

function makeNext(pageSize, cursor) {
  return {
          TAG: /* Next */0,
          _0: {
            pageSize: pageSize,
            cursor: cursor
          }
        };
}

function makePrev(pageSize, cursor) {
  return {
          TAG: /* Prev */1,
          _0: {
            pageSize: pageSize,
            cursor: cursor
          }
        };
}

function encodeForObject(param) {
  if (param.TAG === /* Next */0) {
    var match = param._0;
    return {
            hd: [
              "first",
              match.pageSize
            ],
            tl: {
              hd: [
                "after",
                Curry._1(GraphqlHelpers.Cursor.encode, match.cursor)
              ],
              tl: /* [] */0
            }
          };
  }
  var match$1 = param._0;
  return {
          hd: [
            "last",
            match$1.pageSize
          ],
          tl: {
            hd: [
              "before",
              Curry._1(GraphqlHelpers.Cursor.encode, match$1.cursor)
            ],
            tl: /* [] */0
          }
        };
}

function encode(param) {
  return Relude_Globals.$great$great(encodeForObject, Json.Encode.object_, param);
}

var CursorDirection = {
  next: next,
  prev: prev,
  makeNext: makeNext,
  makePrev: makePrev,
  encodeForObject: encodeForObject,
  encode: encode
};

function make(data) {
  return {
          pageMarkers: Paging_PageMarkers.$$default,
          data: data
        };
}

function makeWithPageMarkers(data, pageMarkers) {
  return {
          pageMarkers: pageMarkers,
          data: data
        };
}

function combine(combineData, direction, param, param$1) {
  return {
          pageMarkers: Paging_PageMarkers.combine(direction, param.pageMarkers, param$1.pageMarkers),
          data: Curry._2(combineData, param.data, param$1.data)
        };
}

function getData(param) {
  return param.data;
}

function getPageMarkers(param) {
  return param.pageMarkers;
}

function map(fn, t) {
  return {
          pageMarkers: t.pageMarkers,
          data: Curry._1(fn, t.data)
        };
}

function resetPaging(param) {
  return {
          pageMarkers: Paging_PageMarkers.$$default,
          data: param.data
        };
}

function compareBy(fn) {
  return function (param, param$1) {
    return Relude_Function.curry2((function (param) {
                  var match = param[1];
                  var match$1 = param[0];
                  var other = Paging_PageMarkers.compare(match$1.pageMarkers, match.pageMarkers);
                  if (other === "less_than" || other === "greater_than") {
                    return other;
                  } else {
                    return Curry._2(fn, match$1.data, match.data);
                  }
                }), param, param$1);
  };
}

function eqBy(fn) {
  return function (param, param$1) {
    return Relude_Function.curry2((function (param) {
                  var match = param[1];
                  var match$1 = param[0];
                  if (Paging_PageMarkers.eq(match$1.pageMarkers, match.pageMarkers)) {
                    return Curry._2(fn, match$1.data, match.data);
                  } else {
                    return false;
                  }
                }), param, param$1);
  };
}

var PagedData = {
  make: make,
  makeWithPageMarkers: makeWithPageMarkers,
  combine: combine,
  getData: getData,
  getPageMarkers: getPageMarkers,
  map: map,
  resetPaging: resetPaging,
  compareBy: compareBy,
  eqBy: eqBy
};

function getPage(combineData, direction, pagedData, fetchData) {
  return function (param) {
    return Relude_Globals.$great$great(fetchData, (function (param) {
                  return Relude_IO.map((function (param) {
                                return Relude_AsyncResult.map((function (param) {
                                              return combine(combineData, direction, pagedData, param);
                                            }), param);
                              }), param);
                }), param);
  };
}

function getPage$1(pageSize, fetchData, direction, combineData, pagedData) {
  var pageMarkers = pagedData.pageMarkers;
  if (direction) {
    var cursor = pageMarkers.prev;
    if (typeof cursor === "number") {
      if (cursor !== 0) {
        return Relude_IO.pure(Relude_AsyncResult.pure(pagedData));
      } else {
        return getPage(combineData, direction, pagedData, fetchData)(undefined);
      }
    } else {
      return getPage(combineData, direction, pagedData, fetchData)(Relude_Option.pure({
                      TAG: /* Prev */1,
                      _0: {
                        pageSize: pageSize,
                        cursor: cursor._0
                      }
                    }));
    }
  }
  var cursor$1 = pageMarkers.next;
  if (typeof cursor$1 === "number") {
    if (cursor$1 !== 0) {
      return Relude_IO.pure(Relude_AsyncResult.pure(pagedData));
    } else {
      return getPage(combineData, direction, pagedData, fetchData)(undefined);
    }
  } else {
    return getPage(combineData, direction, pagedData, fetchData)(Relude_Option.pure({
                    TAG: /* Next */0,
                    _0: {
                      pageSize: pageSize,
                      cursor: cursor$1._0
                    }
                  }));
  }
}

function loadMoreItems(bufferOpt, fetchMoreItems, currentlyShowingIndex) {
  var buffer = bufferOpt !== undefined ? bufferOpt : 10;
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Option.fold(partial_arg, (function (currentItemCount) {
                  if ((currentlyShowingIndex + buffer | 0) >= currentItemCount) {
                    return fetchMoreItems;
                  } else {
                    return Relude_IO.pure(undefined);
                  }
                }), param);
  };
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  if (typeof param === "number") {
                    if (param === /* Init */0) {
                      return Relude_Option.pure(0);
                    } else {
                      return ;
                    }
                  }
                  if (param.TAG === /* Reloading */0) {
                    return ;
                  }
                  var itemCount = param._0;
                  if (itemCount.TAG === /* Ok */0) {
                    return Relude_Option.pure(itemCount._0);
                  }
                  
                }), partial_arg$1, param);
  };
}

var Cursor;

var Direction;

var PageMarkers;

exports.Cursor = Cursor;
exports.Direction = Direction;
exports.PageMarkers = PageMarkers;
exports.CursorDirection = CursorDirection;
exports.PagedData = PagedData;
exports.getPage = getPage$1;
exports.loadMoreItems = loadMoreItems;
/* Json Not a pure module */
